module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Role === '1') ? _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "bannerForm",
    staticClass: "rules",
    attrs: {
      "model": _vm.bannerForm,
      "rules": _vm.bannerFormFules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户协议",
      "label-width": "150px",
      "prop": "user"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bannerForm.user),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "user", $$v)
      },
      expression: "bannerForm.user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务条款",
      "label-width": "150px",
      "prop": "service"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bannerForm.service),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "service", $$v)
      },
      expression: "bannerForm.service"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "租赁协议",
      "label-width": "150px",
      "prop": "liu"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bannerForm.liu),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "liu", $$v)
      },
      expression: "bannerForm.liu"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [(_vm.Role === '1') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 1)], 1)]) : _c('h3', [_vm._v("\n    暂无权限\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40f57d82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/Rules.vue
// module id = 727
// module chunks = 1